import React from "react";

export const LogOutLogo = ({
  width = "30",
  height = "30",
  fill = "none",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "5px" }}
  >
    <path
      d="M5.85276 4.5835C3.83188 5.92715 2.5 8.22478 2.5 10.8335C2.5 14.9757 5.85787 18.3335 10 18.3335C14.1422 18.3335 17.5 14.9757 17.5 10.8335C17.5 8.22478 16.1681 5.92715 14.1472 4.5835"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 1.6665V8.33317"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
